import painPointIcon from '@/resources/prime_stroke.svg'
import addIcon from '@/resources/prime_add.svg'
import store from '@/store'

const PAINPOINT = "PAINPOINT";
const ADD = "ADD";

export default class CustomPalette {
  constructor(bpmnFactory, create, elementFactory, palette, translate) {
    this.bpmnFactory = bpmnFactory;
    this.create = create;
    this.elementFactory = elementFactory;
    this.translate = translate;
    palette.registerProvider(this);
  }

  getPaletteEntries(element) {
    const {
      bpmnFactory,
      create,
      elementFactory,
      translate
    } = this;

    function startCreate(taskType, icon) {
/*       if(taskType == "GROUP") return; */
      return function(event){
       const contextInformation = bpmnFactory.create('bpmn:DataStoreReference');
       
       contextInformation.taskType = taskType;
       contextInformation.icon = icon;
       
       var shape = elementFactory.createShape({
        type: 'bpmn:DataStoreReference',
        businessObject: contextInformation
       });
   
       create.start(event, shape); 
  
      }
    }

    let elements = JSON.parse(JSON.stringify(store.state.customModelingElements));
    if(elements != null){
      for(const [key, value] of Object.entries(elements)){
        const actions =  {
          dragstart: startCreate(value.taskType, value.imageUrl),
          click: startCreate(value.taskType, value.imageUrl)
        }
        elements[key].action = actions;
        elements[key].group = 'custom';
      }
    }else{
      elements = {};
    }
    elements['create.add'] = {
      group: 'add',
      title: translate('Add custom modeling icon'),
      imageUrl: addIcon,
      taskType: 'ADD',
      action: {
        dragstart: startCreate(ADD, addIcon),
        click: startCreate(ADD, addIcon)
      }
    }
    elements['create.painpoint'] = {
      group: 'custom',
      title: translate('Create Pain Point'),
      imageUrl: painPointIcon,
      action: {
        dragstart: startCreate(PAINPOINT, painPointIcon),
        click: startCreate(PAINPOINT, painPointIcon)
      }
    }
    return elements;
      
  }

  
   
}

CustomPalette.$inject = [
  'bpmnFactory',
  'create',
  'elementFactory',
  'palette',
  'translate'
];